import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef } from "react";
import { useTheme } from "../context/ThemeContext";
export function withTokens(Component) {
    const WrappedComponent = forwardRef((props, ref) => {
        const { theme } = useTheme();
        const finalProps = {
            ...props,
            tokens: theme,
            ref,
        };
        return _jsx(Component, { ...finalProps });
    });
    const componentName = Component.displayName || Component.name || "Component";
    WrappedComponent.displayName = `withTokens(${componentName})`;
    return WrappedComponent;
}
//# sourceMappingURL=withTokens.js.map